import React, { useEffect } from "react";
import { head, input, remarkStyle, signature } from "../../helper";
import "./mcqCard.css";
import DefaultImage from "../../../../../images/Navbar/2xcell-signature.png";
import { htmlDecode } from "../../../../../utils/parse";
import { QuestionImg } from "../../../../LearningResources/Assement/Image";
import TestOption from "../../Option";

const isChecked = (id, optionId) => {
  return localStorage.getItem(id) === optionId;
};

function McqCard({
  color = "",
  data,
  number,
  correctAnswer,
  setCorrectAnswer,
  onlineTestId,
}) {
  const question = data;
  const id = onlineTestId + "," + question._id;

  const handleClick = (e) => {
    localStorage.getItem(id) === e.target.value
      ? localStorage.removeItem(id)
      : localStorage.setItem(id, e.target.value);
    setCorrectAnswer(e.target.value);
  };

  //Uncheck all the options when a new question is rendered
  useEffect(() => {
    if (localStorage.getItem(id)) return;

    const radios = document.querySelectorAll(".mcq_radio");
    radios.forEach((radio) => {
      radio.checked = false;
    });
  }, [number]);

  useEffect(() => {
      if(window.MathJax) {
        window.MathJax.typesetPromise();
      }
    },[question.question]);
  

  return (
    <>
      <div className="container question_card  my-4">
        <div className="superhead">
          <div className="remark" style={remarkStyle(color)}>
            Select Single Option{" "}
          </div>
          <div className="mcq__head" style={head(color)}>
            <div className="mcqCard">
              <div className="mcqCard__left">
                <h6
                  style={{ fontWeight: "bolder", marginTop: "5px" }}
                  dangerouslySetInnerHTML={{
                    __html: htmlDecode(`Q${number}. ${question?.question}`),
                  }}
                ></h6>
              </div>
            </div>
            <div className="main_div">
              {question?.images?.questionImg ? (
                <QuestionImg image={question?.images?.questionImg} />
              ) : null}
              <div
                className="mcq"
                style={
                  question?.images?.op1 ? { width: "70%" } : { width: "80%" }
                }
              >
                <div className="up top-left">
                  <TestOption
                    image={question.images?.op1}
                    option={question.options[0]}
                    isChecked={isChecked(id, question?.options[0]?.optionId)}
                    select={handleClick}
                    type="radio"
                  />
                </div>
                <div className="up top-right">
                  <TestOption
                    image={question.images?.op2}
                    option={question.options[1]}
                    isChecked={isChecked(id, question?.options[1]?.optionId)}
                    select={handleClick}
                    type="radio"
                  />
                </div>
                <div className="up bottom-left">
                  <TestOption
                    image={question.images?.op3}
                    option={question.options[2]}
                    isChecked={isChecked(id, question?.options[2]?.optionId)}
                    select={handleClick}
                    type="radio"
                  />
                </div>
                <div className="up bottom-right">
                  <TestOption
                    image={question.images?.op4}
                    option={question.options[3]}
                    isChecked={isChecked(id, question?.options[3]?.optionId)}
                    select={handleClick}
                    type="radio"
                  />
                </div>
              </div>
            </div>
            <div className="last">
              {question.onModel === "admin" && question.creatorId ? (
                <img
                  src={DefaultImage}
                  className="signarture"
                  style={{ ...signature(color), width: "50px" }}
                />
              ) : (
                <div className="signarture" style={signature(color)}>
                  {question.creatorId ? question.creatorId.name : ""}
                  <br />
                  {question.schoolId.name}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default McqCard;
